import object1 from "./1.png";

export const royalBeauty1 = [object1, object1, object1, object1, object1];
